import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-category-carousel-wrapper',
  templateUrl: './category-carousel-wrapper.component.html',
})
export class CategoryCarouselWrapperComponent {
  @Input() title?: string;
  @Input() limit?: number;
}
